import React from "react";

import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faParagraph,
  faText,
  faFileExport,
  faSignOutAlt,
  faMinusCircle,
  faPlusCircle
} from "@fortawesome/pro-regular-svg-icons";
import {
  faGripLinesVertical,
  faLevelDown
} from "@fortawesome/pro-light-svg-icons";

import { ReactComponent as PunctumQuadratum } from "../svg/shapes/PunctumQuadratum.svg";
import { ReactComponent as DoClef } from "../svg/shapes/DoClef.svg";
import { ReactComponent as DoClefWithFlat } from "../svg/shapes/DoClefWithFlat.svg";
import { ReactComponent as FaClef } from "../svg/shapes/FaClef.svg";

import ExportPreview from "./ExportPreview";

import "../scss/bootstrap-custom.scss";
import "../scss/NavigationHeader.scss";

function NavigationHeader({
  user,
  statusDisplay,
  onLogOut,
  zoom,
  onZoom,
  document: doc
}) {
  const zoomString = Math.round(zoom * 100).toString() + "%";
  const userPopover = (
    <Popover>
      <Popover.Title className="d-flex flex-column">
        <h4 className="mb-0">{user.name}</h4>
        <small className="text-muted">{user.email}</small>
      </Popover.Title>
      <Popover.Content
        as={Button}
        variant="light"
        className="w-100 text-left"
        onClick={onLogOut}
      >
        <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
        Log Out
      </Popover.Content>
    </Popover>
  );
  const exportPopover = (
    <Popover className="ExportPreviewPopover d-print-none">
      <Popover.Content>
        <ExportPreview document={doc} />
      </Popover.Content>
    </Popover>
  );
  const showDropdowns = false;
  return (
    <header className="NavigationHeader d-flex justify-content-between d-print-none">
      <div className="position-relative flex-grow-1">
        <div
          className="position-absolute d-flex align-items-center ml-3"
          style={{ left: 0, top: 0, bottom: 0 }}
        >
          <embed style={{ pointerEvents: 'none' }} src={`${process.env.PUBLIC_URL}/large-logo.svg`} height="35" width="280" />
          <span className="editor-title ml-2">Editor</span>
          <span className="badge badge-info ml-2">Alpha</span>
          {statusDisplay && statusDisplay.icon && (
            <FontAwesomeIcon
              icon={statusDisplay.icon}
              className="mr-2"
              style={{ fontSize: "1.45em" }}
            />
          )}
          {statusDisplay && statusDisplay.message && (
            <div>{statusDisplay.message}</div>
          )}
        </div>
      </div>
      <div className="NavigationDropdowns d-flex">
      { showDropdowns && <>
        <Dropdown className="mx-2 position-relative">
          <Dropdown.Toggle variant="light">
            <FontAwesomeIcon icon={faParagraph} />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item>
              <PunctumQuadratum className="NavigationDropdown-Icon" />
              Note
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item>
              <DoClef className="NavigationDropdown-Icon" />
              Do Clef
            </Dropdown.Item>
            <Dropdown.Item>
              <DoClefWithFlat className="NavigationDropdown-Icon" />
              Do Clef with Flat
            </Dropdown.Item>
            <Dropdown.Item>
              <FaClef className="NavigationDropdown-Icon" />
              Fa Clef
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item>
              <FontAwesomeIcon
                icon={faGripLinesVertical}
                className="NavigationDropdown-Icon fa-w-16 p-0"
              />
              Bar Line
            </Dropdown.Item>
            <Dropdown.Item>
              <FontAwesomeIcon
                icon={faLevelDown}
                rotation={90}
                className="NavigationDropdown-Icon fa-w-16 p-1"
              />
              Line Break
            </Dropdown.Item>
          </Dropdown.Menu>
          <Form.Label className="position-absolute NavigationDropdown-Label">
            Insert
          </Form.Label>
        </Dropdown>
        <Dropdown className="mx-2 position-relative">
          <Dropdown.Toggle variant="light">
            <FontAwesomeIcon icon={faText} />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Header>Staff Text</Dropdown.Header>
            <Dropdown.Item>Lyrics</Dropdown.Item>
            <Dropdown.Item>Chord Symbols</Dropdown.Item>
            <Dropdown.Item>Above Staff Text</Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Header>Document Text</Dropdown.Header>
            <Dropdown.Item>Supertitle</Dropdown.Item>
            <Dropdown.Item>Title</Dropdown.Item>
            <Dropdown.Item>Subtitle</Dropdown.Item>
            <Dropdown.Item>Annotation</Dropdown.Item>
            <Dropdown.Item>Text Left</Dropdown.Item>
            <Dropdown.Item>Text Right</Dropdown.Item>
          </Dropdown.Menu>
          <Form.Label className="position-absolute NavigationDropdown-Label">
            Text
          </Form.Label>
        </Dropdown>
        <Dropdown className="mx-2 position-relative">
          <Dropdown.Toggle variant="light">
            <span
              className="versiculum"
              style={{ fontSize: "1.75em", lineHeight: "0.85" }}
            >
              v
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item>
              <span className="versiculum NavigationDropdown-Icon mr-2">v</span>
              Versicle
            </Dropdown.Item>
            <Dropdown.Item>
              <span className="versiculum NavigationDropdown-Icon mr-2">r</span>
              Response
            </Dropdown.Item>
            <Dropdown.Item>
              <span className="versiculum NavigationDropdown-Icon mr-2">a</span>
              Antiphon
            </Dropdown.Item>
          </Dropdown.Menu>
          <Form.Label className="position-absolute NavigationDropdown-Label">
            Symbols
          </Form.Label>
        </Dropdown>
      </>}
      </div>
      <div className="position-relative flex-grow-1" style={{ height: 35 }}>
        <div
          className="position-absolute d-flex mr-3"
          style={{ right: 0, top: 0, bottom: 0 }}
        >
          <a href="/editor/legacy/" className="btn-link mr-4 btn-link-light align-self-center">Return to Legacy Editor</a>
          <div className="position-relative d-flex flex-column justify-content-center mr-4">
            <ButtonGroup>
              <Button variant="light m-auto" onClick={() => onZoom(zoom / 1.2)}>
                <FontAwesomeIcon icon={faMinusCircle} />
              </Button>
              <Button variant="light" disabled style={{ width: "9ch" }}>
                {zoomString}
              </Button>
              <Button variant="light m-auto" onClick={() => onZoom(zoom * 1.2)}>
                <FontAwesomeIcon icon={faPlusCircle} />
              </Button>
            </ButtonGroup>
            <Form.Label className="position-absolute NavigationDropdown-Label">
              Zoom
            </Form.Label>
          </div>
          <div className="position-relative d-flex flex-column justify-content-center">
            <OverlayTrigger
              trigger="click"
              placement="bottom"
              overlay={exportPopover}
              rootClose={true}
            >
              <Button variant="light m-auto">
                <FontAwesomeIcon icon={faFileExport} />
              </Button>
            </OverlayTrigger>
            <Form.Label className="position-absolute NavigationDropdown-Label">
              Export
            </Form.Label>
          </div>
        </div>
      </div>
    </header>
  );
}

export default NavigationHeader;
